import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/shift-template', { params }),
  getByID: id => axios.get(`/api/v1/avg/shift-template/${id}`),
  create: params => axios.post('/api/v1/avg/shift-template', params),
  update: params => axios.put(`/api/v1/avg/shift-template/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/shift-template', { params })
};
